import './ConvertLead.css'
import { generate } from 'generate-password-browser';
import { useEffect, useState } from 'react';
import { formNotificationStyle2 } from '../../utilities/services/formNotification';
import { updateLead } from '../../utilities/api/leads';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import { createClient, getClientIDs } from '../../utilities/api/clients';
import { useNavigate } from 'react-router-dom';


export default function ConvertLead({user, leadItem, clientEmails, getLeads, toggleNotifications}) {
  const [isLeadNameValid, setIsLeadNameValid] = useState(false)
  const passwordLength = 12
  const [isEmailValid, setIsEmailValid] = useState(false)
  const [isPhoneValid, setIsPhoneValid] = useState(false)
  const [isAddressValid, setIsAddressValid] = useState(false)
  const [isRepresentativeValid, setIsRepresentativeValid] = useState(false)
  const [isDataComplete, setIsDataComplete] = useState(false)
  const navigation = useNavigate()
  const [randomPassword, setRandomPassword] = useState('')

  const clientData = {
    companyName: leadItem.leadName,
    companyEmail: leadItem.email,
    representative: leadItem.contactName,
    phone: leadItem.phone || 'NA',
    canada: leadItem.canada,
    province: leadItem.province,
    address: leadItem.address,
    clientPassword: randomPassword,
  }

  const generateClientID = async () => {
    try {
      const clientIDs = await getClientIDs()
      let newClientID = 80
      while (clientIDs.includes(newClientID)) {
        newClientID++
      }
      return newClientID
    } catch (error) {
      console.log(error)
    }
  }

  const generatePassword = () => {
      const password = generate({
          length: passwordLength,
          numbers: true,
      });
      setRandomPassword(password)
  }

  const validateName = async (name) => {
    if (name) {
      setIsLeadNameValid(true)
    } else {
      setIsLeadNameValid(false)
    }
  }

  const validateEmail = async (email) => {
    if (leadItem) {
      if (clientEmails.includes(email)) {
        setIsEmailValid(false)
      } else {
        setIsEmailValid(true)
      }
    }
  }

  const validatePhone = async (phone) => {
    if (phone) {
      setIsPhoneValid(true)
    } else {
      setIsPhoneValid(false)
    }
  }

  const validateAddress = async (address) => {
    if (address) {
      setIsAddressValid(true)
    } else {
      setIsAddressValid(false)
    }
  }

  const validateRepresentative = async (representative) => {
    if (representative) {
      setIsRepresentativeValid(true)
    } else {
      setIsRepresentativeValid(false)
    }
  }

  const createNewClient = async () => {
    const newClientID = await generateClientID()
    const newClientData = {
      ...clientData,
      clientID: newClientID,
      userID: user._id,
    }
    try {
      const client = await createClient(newClientData)
      await updateLead(leadItem._id, {...leadItem, status: 'converted'})
      await toggleNotifications('success', `Lead "${capitalizeFirstLetter(leadItem.leadName)}" Converted to Client!`, '#FFFFFF')
      formNotificationStyle2(`leadConversionNotification${leadItem._id}`, 'Lead Converted to Client!', '#0A7637', '1')
      // await getLeads()
      setTimeout(() => {
        navigation(`/clients/${client._id}`)
      }, 1500)
    } catch (error) {
      await toggleNotifications('error', `Failed to Convert Lead "${capitalizeFirstLetter(leadItem.leadName)}"!`, '#FFFFFF')
      formNotificationStyle2(`leadConversionNotification${leadItem._id}`, 'Failed to Convert Lead!', '#CA150C', '1')
      console.log(error)
    }
  }

  useEffect(() => {
    validateName(clientData.companyName)
    validateEmail(clientData.companyEmail)
    validatePhone(clientData.phone)
    validateAddress(clientData.address)
    validateRepresentative(clientData.representative)
    if (isLeadNameValid && isEmailValid && isPhoneValid && isAddressValid && isRepresentativeValid) {
      setIsDataComplete(true)
    } else {
      setIsDataComplete(false)
    }
    // eslint-disable-next-line
  },[leadItem])

  useEffect(() => {
    if (isLeadNameValid && isEmailValid && isPhoneValid && isAddressValid && isRepresentativeValid) {
      setIsDataComplete(true)
    } else {
      setIsDataComplete(false)
    }
    // eslint-disable-next-line
  },[isLeadNameValid && isEmailValid && isPhoneValid && isAddressValid && isRepresentativeValid])

  useEffect(() => {
    generatePassword()
    // eslint-disable-next-line
  }, [])


  return (
    <div className='ConvertLead modal fade' id={`convertLeadModal${leadItem._id}`}  data-bs-keyboard="true">
      <div className="modal-dialog">
        <div className="modal-content contentContainer">
          <div className='header'>
            <div className='left'>
              <div className='first'>
                <svg width="30" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" opacity='0.8'>
                  <path d="M1.6665 14.1666L9.99984 18.3333L18.3332 14.1666M1.6665 9.99996L9.99984 14.1666L18.3332 9.99996M9.99984 1.66663L1.6665 5.83329L9.99984 9.99996L18.3332 5.83329L9.99984 1.66663Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>                    
                </svg>
              </div>
              <div className='second'>
                <div className='sec1'>
                  Convert 
                  <span className='primaryText ps-1 pe-1'>{capitalizeFirstLetter(leadItem.leadName)}</span>
                    to a client
                </div>
              </div>
            </div>
            <div className='right'>
              <svg data-bs-dismiss="modal" width="25" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="16.2666" cy="16.2666" r="15.7666" fill="#EDEFF2" stroke="#EEEEEE"/>
                <path d="M21.1093 12L12 21.1093M12 12L21.1093 21.1093" stroke="#1B2B41" strokeOpacity="0.8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </div>
          <div className='mainContent' id={`convertLeadContent${leadItem._id}`}>
            <div className='content'>
              <div className='text'>
                <div className='title'>Lead Name: </div>
                <div className='value'>{capitalizeFirstLetter(clientData.companyName)}</div>
              </div>
              { isLeadNameValid ? 
              <div className='isValid'>
                <svg width='13' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" enableBackground="new 0 0 64 64">
                  <circle cx="32" cy="32" r="30" fill="#fff"/>
                  <path d="M32,2C15.431,2,2,15.432,2,32c0,16.568,13.432,30,30,30c16.568,0,30-13.432,30-30C62,15.432,48.568,2,32,2z M25.025,50l-0.02-0.02L24.988,50L11,35.6l7.029-7.164l6.977,7.184l21-21.619L53,21.199L25.025,50z" fill="#43a047"/>
                </svg>
                <div>&nbsp;&nbsp;Name is valid</div>
              </div> 
              : 
              <div className='isNotValid'>
                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" width="13" viewBox="0 0 256 256" xmlSpace="preserve">
                  <g style={{'stroke': 'none', 'strokeWidth': '0', 'strokeDasharray': 'none', 'strokeLinecap': 'butt', 'strokeLinejoin': 'miter', 'strokeMiterlimit': '10', 'fill': 'none', 'fillRule': 'nonzero', 'opacity': '1',}} transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)" >
                    <path d="M 45 90 C 20.187 90 0 69.813 0 45 C 0 20.187 20.187 0 45 0 c 24.813 0 45 20.187 45 45 C 90 69.813 69.813 90 45 90 z" style={{'stroke': 'none', 'strokeWidth': '1', 'strokeDasharray': 'none', 'strokeLinecap': 'butt', 'strokeLinejoin': 'miter', 'strokeMiterlimit': '10', 'fill': 'rgb(236,0,0)', 'fillRule': 'nonzero', 'opacity': '1'}} transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
                    <path d="M 28.5 65.5 c -1.024 0 -2.047 -0.391 -2.829 -1.172 c -1.562 -1.562 -1.562 -4.095 0 -5.656 l 33 -33 c 1.561 -1.562 4.096 -1.562 5.656 0 c 1.563 1.563 1.563 4.095 0 5.657 l -33 33 C 30.547 65.109 29.524 65.5 28.5 65.5 z" style={{'stroke': 'none', 'strokeWidth': '1', 'strokeDasharray': 'none', 'strokeLinecap': 'butt', 'strokeLinejoin': 'miter', 'strokeMiterlimit': '10', 'fill': 'rgb(255,255,255)', 'fillRule': 'nonzero', 'opacity': '1'}} transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
                    <path d="M 61.5 65.5 c -1.023 0 -2.048 -0.391 -2.828 -1.172 l -33 -33 c -1.562 -1.563 -1.562 -4.095 0 -5.657 c 1.563 -1.562 4.095 -1.562 5.657 0 l 33 33 c 1.563 1.562 1.563 4.095 0 5.656 C 63.548 65.109 62.523 65.5 61.5 65.5 z" style={{'stroke': 'none', 'strokeWidth': '1', 'strokeDasharray': 'none', 'strokeLinecap': 'butt', 'strokeLinejoin': 'miter', 'strokeMiterlimit': '10', 'fill': 'rgb(255,255,255)', 'fillRule': 'nonzero', 'opacity': '1'}} transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
                  </g>
                </svg>
                <div>&nbsp;&nbsp;Name is invalid</div>
              </div> 
              }
            </div>
            <div className='content'>
              <div className='text'>
                <div className='title'>Email: </div>
                <div className='value'>{clientData.companyEmail}</div>
              </div>
              { isEmailValid ?
              <div className='isValid'>
                <svg width='13' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" enableBackground="new 0 0 64 64">
                  <circle cx="32" cy="32" r="30" fill="#fff"/>
                  <path d="M32,2C15.431,2,2,15.432,2,32c0,16.568,13.432,30,30,30c16.568,0,30-13.432,30-30C62,15.432,48.568,2,32,2z M25.025,50l-0.02-0.02L24.988,50L11,35.6l7.029-7.164l6.977,7.184l21-21.619L53,21.199L25.025,50z" fill="#43a047"/>
                </svg>
                <div>&nbsp;&nbsp;Email is valid</div>
              </div> 
              : 
              <div className='isNotValid'>
                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" width="13" viewBox="0 0 256 256" xmlSpace="preserve">
                  <g style={{'stroke': 'none', 'strokeWidth': '0', 'strokeDasharray': 'none', 'strokeLinecap': 'butt', 'strokeLinejoin': 'miter', 'strokeMiterlimit': '10', 'fill': 'none', 'fillRule': 'nonzero', 'opacity': '1',}} transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)" >
                    <path d="M 45 90 C 20.187 90 0 69.813 0 45 C 0 20.187 20.187 0 45 0 c 24.813 0 45 20.187 45 45 C 90 69.813 69.813 90 45 90 z" style={{'stroke': 'none', 'strokeWidth': '1', 'strokeDasharray': 'none', 'strokeLinecap': 'butt', 'strokeLinejoin': 'miter', 'strokeMiterlimit': '10', 'fill': 'rgb(236,0,0)', 'fillRule': 'nonzero', 'opacity': '1'}} transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
                    <path d="M 28.5 65.5 c -1.024 0 -2.047 -0.391 -2.829 -1.172 c -1.562 -1.562 -1.562 -4.095 0 -5.656 l 33 -33 c 1.561 -1.562 4.096 -1.562 5.656 0 c 1.563 1.563 1.563 4.095 0 5.657 l -33 33 C 30.547 65.109 29.524 65.5 28.5 65.5 z" style={{'stroke': 'none', 'strokeWidth': '1', 'strokeDasharray': 'none', 'strokeLinecap': 'butt', 'strokeLinejoin': 'miter', 'strokeMiterlimit': '10', 'fill': 'rgb(255,255,255)', 'fillRule': 'nonzero', 'opacity': '1'}} transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
                    <path d="M 61.5 65.5 c -1.023 0 -2.048 -0.391 -2.828 -1.172 l -33 -33 c -1.562 -1.563 -1.562 -4.095 0 -5.657 c 1.563 -1.562 4.095 -1.562 5.657 0 l 33 33 c 1.563 1.562 1.563 4.095 0 5.656 C 63.548 65.109 62.523 65.5 61.5 65.5 z" style={{'stroke': 'none', 'strokeWidth': '1', 'strokeDasharray': 'none', 'strokeLinecap': 'butt', 'strokeLinejoin': 'miter', 'strokeMiterlimit': '10', 'fill': 'rgb(255,255,255)', 'fillRule': 'nonzero', 'opacity': '1'}} transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
                  </g>
                </svg>
                <div>&nbsp;&nbsp;Email is invalid. A client with the same email exists</div>
              </div>
              }
            </div>
            <div className='content'>
              <div className='text'>
                <div className='title'>Phone: </div>
                <div className='value'>{clientData.phone  || '---'}</div>
              </div>
              { isPhoneValid ?
              <div className='isValid'>
                <svg width='13' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" enableBackground="new 0 0 64 64">
                  <circle cx="32" cy="32" r="30" fill="#fff"/>
                  <path d="M32,2C15.431,2,2,15.432,2,32c0,16.568,13.432,30,30,30c16.568,0,30-13.432,30-30C62,15.432,48.568,2,32,2z M25.025,50l-0.02-0.02L24.988,50L11,35.6l7.029-7.164l6.977,7.184l21-21.619L53,21.199L25.025,50z" fill="#43a047"/>
                </svg>
                <div>&nbsp;&nbsp;Phone number is valid</div>
              </div> 
              : 
              <div className='isNotValid'>
                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" width="13" viewBox="0 0 256 256" xmlSpace="preserve">
                  <g style={{'stroke': 'none', 'strokeWidth': '0', 'strokeDasharray': 'none', 'strokeLinecap': 'butt', 'strokeLinejoin': 'miter', 'strokeMiterlimit': '10', 'fill': 'none', 'fillRule': 'nonzero', 'opacity': '1',}} transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)" >
                    <path d="M 45 90 C 20.187 90 0 69.813 0 45 C 0 20.187 20.187 0 45 0 c 24.813 0 45 20.187 45 45 C 90 69.813 69.813 90 45 90 z" style={{'stroke': 'none', 'strokeWidth': '1', 'strokeDasharray': 'none', 'strokeLinecap': 'butt', 'strokeLinejoin': 'miter', 'strokeMiterlimit': '10', 'fill': 'rgb(236,0,0)', 'fillRule': 'nonzero', 'opacity': '1'}} transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
                    <path d="M 28.5 65.5 c -1.024 0 -2.047 -0.391 -2.829 -1.172 c -1.562 -1.562 -1.562 -4.095 0 -5.656 l 33 -33 c 1.561 -1.562 4.096 -1.562 5.656 0 c 1.563 1.563 1.563 4.095 0 5.657 l -33 33 C 30.547 65.109 29.524 65.5 28.5 65.5 z" style={{'stroke': 'none', 'strokeWidth': '1', 'strokeDasharray': 'none', 'strokeLinecap': 'butt', 'strokeLinejoin': 'miter', 'strokeMiterlimit': '10', 'fill': 'rgb(255,255,255)', 'fillRule': 'nonzero', 'opacity': '1'}} transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
                    <path d="M 61.5 65.5 c -1.023 0 -2.048 -0.391 -2.828 -1.172 l -33 -33 c -1.562 -1.563 -1.562 -4.095 0 -5.657 c 1.563 -1.562 4.095 -1.562 5.657 0 l 33 33 c 1.563 1.562 1.563 4.095 0 5.656 C 63.548 65.109 62.523 65.5 61.5 65.5 z" style={{'stroke': 'none', 'strokeWidth': '1', 'strokeDasharray': 'none', 'strokeLinecap': 'butt', 'strokeLinejoin': 'miter', 'strokeMiterlimit': '10', 'fill': 'rgb(255,255,255)', 'fillRule': 'nonzero', 'opacity': '1'}} transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
                  </g>
                </svg>
                <div>&nbsp;&nbsp;Phone number is invalid</div>
              </div>
              }
            </div>
            <div className='content'>
              <div className='text'>
                <div className='title'>Address: </div>
                <div className='value'>{clientData.address || '---'}</div>
              </div>
              { isAddressValid ?
              <div className='isValid'>
                <svg width='13' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" enableBackground="new 0 0 64 64">
                  <circle cx="32" cy="32" r="30" fill="#fff"/>
                  <path d="M32,2C15.431,2,2,15.432,2,32c0,16.568,13.432,30,30,30c16.568,0,30-13.432,30-30C62,15.432,48.568,2,32,2z M25.025,50l-0.02-0.02L24.988,50L11,35.6l7.029-7.164l6.977,7.184l21-21.619L53,21.199L25.025,50z" fill="#43a047"/>
                </svg>
                <div>&nbsp;&nbsp;Address is valid</div>
              </div> 
              : 
              <div className='isNotValid'>
                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" width="13" viewBox="0 0 256 256" xmlSpace="preserve">
                  <g style={{'stroke': 'none', 'strokeWidth': '0', 'strokeDasharray': 'none', 'strokeLinecap': 'butt', 'strokeLinejoin': 'miter', 'strokeMiterlimit': '10', 'fill': 'none', 'fillRule': 'nonzero', 'opacity': '1',}} transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)" >
                    <path d="M 45 90 C 20.187 90 0 69.813 0 45 C 0 20.187 20.187 0 45 0 c 24.813 0 45 20.187 45 45 C 90 69.813 69.813 90 45 90 z" style={{'stroke': 'none', 'strokeWidth': '1', 'strokeDasharray': 'none', 'strokeLinecap': 'butt', 'strokeLinejoin': 'miter', 'strokeMiterlimit': '10', 'fill': 'rgb(236,0,0)', 'fillRule': 'nonzero', 'opacity': '1'}} transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
                    <path d="M 28.5 65.5 c -1.024 0 -2.047 -0.391 -2.829 -1.172 c -1.562 -1.562 -1.562 -4.095 0 -5.656 l 33 -33 c 1.561 -1.562 4.096 -1.562 5.656 0 c 1.563 1.563 1.563 4.095 0 5.657 l -33 33 C 30.547 65.109 29.524 65.5 28.5 65.5 z" style={{'stroke': 'none', 'strokeWidth': '1', 'strokeDasharray': 'none', 'strokeLinecap': 'butt', 'strokeLinejoin': 'miter', 'strokeMiterlimit': '10', 'fill': 'rgb(255,255,255)', 'fillRule': 'nonzero', 'opacity': '1'}} transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
                    <path d="M 61.5 65.5 c -1.023 0 -2.048 -0.391 -2.828 -1.172 l -33 -33 c -1.562 -1.563 -1.562 -4.095 0 -5.657 c 1.563 -1.562 4.095 -1.562 5.657 0 l 33 33 c 1.563 1.562 1.563 4.095 0 5.656 C 63.548 65.109 62.523 65.5 61.5 65.5 z" style={{'stroke': 'none', 'strokeWidth': '1', 'strokeDasharray': 'none', 'strokeLinecap': 'butt', 'strokeLinejoin': 'miter', 'strokeMiterlimit': '10', 'fill': 'rgb(255,255,255)', 'fillRule': 'nonzero', 'opacity': '1'}} transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
                  </g>
                </svg>
                <div>&nbsp;&nbsp;Address is invalid. Please update this field</div>
              </div>
              }
            </div>
            <div className='content'>
              <div className='text'>
                <div className='title'>Contact Name: </div>
                <div className='value'>{capitalizeFirstLetter(clientData.representative) || '---'}</div>
              </div>
              { isRepresentativeValid ?
              <div className='isValid'>
                <svg width='13' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" enableBackground="new 0 0 64 64">
                  <circle cx="32" cy="32" r="30" fill="#fff"/>
                  <path d="M32,2C15.431,2,2,15.432,2,32c0,16.568,13.432,30,30,30c16.568,0,30-13.432,30-30C62,15.432,48.568,2,32,2z M25.025,50l-0.02-0.02L24.988,50L11,35.6l7.029-7.164l6.977,7.184l21-21.619L53,21.199L25.025,50z" fill="#43a047"/>
                </svg>
                <div>&nbsp;&nbsp;Representative is valid</div>
              </div> 
              : 
              <div className='isNotValid'>
                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" width="13" viewBox="0 0 256 256" xmlSpace="preserve">
                  <g style={{'stroke': 'none', 'strokeWidth': '0', 'strokeDasharray': 'none', 'strokeLinecap': 'butt', 'strokeLinejoin': 'miter', 'strokeMiterlimit': '10', 'fill': 'none', 'fillRule': 'nonzero', 'opacity': '1',}} transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)" >
                    <path d="M 45 90 C 20.187 90 0 69.813 0 45 C 0 20.187 20.187 0 45 0 c 24.813 0 45 20.187 45 45 C 90 69.813 69.813 90 45 90 z" style={{'stroke': 'none', 'strokeWidth': '1', 'strokeDasharray': 'none', 'strokeLinecap': 'butt', 'strokeLinejoin': 'miter', 'strokeMiterlimit': '10', 'fill': 'rgb(236,0,0)', 'fillRule': 'nonzero', 'opacity': '1'}} transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
                    <path d="M 28.5 65.5 c -1.024 0 -2.047 -0.391 -2.829 -1.172 c -1.562 -1.562 -1.562 -4.095 0 -5.656 l 33 -33 c 1.561 -1.562 4.096 -1.562 5.656 0 c 1.563 1.563 1.563 4.095 0 5.657 l -33 33 C 30.547 65.109 29.524 65.5 28.5 65.5 z" style={{'stroke': 'none', 'strokeWidth': '1', 'strokeDasharray': 'none', 'strokeLinecap': 'butt', 'strokeLinejoin': 'miter', 'strokeMiterlimit': '10', 'fill': 'rgb(255,255,255)', 'fillRule': 'nonzero', 'opacity': '1'}} transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
                    <path d="M 61.5 65.5 c -1.023 0 -2.048 -0.391 -2.828 -1.172 l -33 -33 c -1.562 -1.563 -1.562 -4.095 0 -5.657 c 1.563 -1.562 4.095 -1.562 5.657 0 l 33 33 c 1.563 1.562 1.563 4.095 0 5.656 C 63.548 65.109 62.523 65.5 61.5 65.5 z" style={{'stroke': 'none', 'strokeWidth': '1', 'strokeDasharray': 'none', 'strokeLinecap': 'butt', 'strokeLinejoin': 'miter', 'strokeMiterlimit': '10', 'fill': 'rgb(255,255,255)', 'fillRule': 'nonzero', 'opacity': '1'}} transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
                  </g>
                </svg>
                <div>&nbsp;&nbsp;Representative is invalid. Please update this field</div>
              </div>
              }
            </div>
            <div className='content'>
              <div className='text'>
                <div className='title'>Password: </div>
                <div className='value'>{clientData.clientPassword}</div>
              </div>
            </div>
          </div>
          <div id={`leadConversionNotification${leadItem._id}`}className='leadConversionNotification text-center mb-2'></div>
          <div className='d-flex justify-content-center contentButtonContainer'>
            <button data-bs-dismiss="modal" className='cancel'>Cancel</button>
            <button data-bs-dismiss="modal" className="success submit" type="button" onClick={createNewClient} disabled={isDataComplete===false}>Convert to Client</button>
          </div>
        </div>
      </div>
    </div>
  )
}
